import { useCallback, useMemo } from 'react';

import { SCRAPER_NAME } from '@/features/Scraping/types';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { isProdMode } from '@/utils/environment';

import { KYOBO_WORKSPACE_ALIAS } from './config';

export const useKyobo = () => {
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);
  const isKyobo = useMemo(() => {
    return currWorkspace?.alias === KYOBO_WORKSPACE_ALIAS;
  }, [currWorkspace]);

  const filterKyoboOnlyScraperOptions = useCallback(
    (scraperOptions: SCRAPER_NAME[]) => {
      // 교보 워크스페이스가 아닌경우 SCRAPER_NAME.NaverCafeAccountBase scraper 제외처리
      if (isKyobo) return scraperOptions;
      // production이 아닌경우 전체 노출
      if (!isProdMode()) return scraperOptions;
      return scraperOptions.filter(
        (option) => option !== SCRAPER_NAME.NaverCafeAccountBase,
      );
    },
    [isKyobo],
  );

  return {
    isKyobo,
    filterKyoboOnlyScraperOptions,
  };
};
